import { parseAsBoolean } from "nuqs";

import { usePersistedQueryStates } from "@/src/hooks/use-persisted-query-states";

export function useTaskFilters() {
  return usePersistedQueryStates({
    showCompleted: parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: false }),
  });
}

export type TaskFilters = ReturnType<typeof useTaskFilters>[0];
